import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img
                src="/images/wsk-logo-light.png"
                alt="WSK Logistika"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Profesionalūs logistikos sprendimai jūsų verslui. Efektyvus sandėliavimas,
              krovos darbai ir tiekimo grandinės valdymas Kaune.
            </p>
            <div className="space-y-2">
              <div className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-blue-500 mt-0.5" />
                <span>Nemajūnų g. 19, LT-52459 Kaunas</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-blue-500" />
                <a href="tel:+37065017855" className="hover:text-blue-400 transition-colors">
                  +370 650 17855
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-blue-500" />
                <a href="mailto:info@wsklogistika.lt" className="hover:text-blue-400 transition-colors">
                  info@wsklogistika.lt
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Greitos nuorodos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-blue-400 transition-colors">
                  Pagrindinis
                </Link>
              </li>
              <li>
                <Link to="/apie-mus" className="hover:text-blue-400 transition-colors">
                  Apie mus
                </Link>
              </li>
              <li>
                <Link to="/paslaugos" className="hover:text-blue-400 transition-colors">
                  Paslaugos
                </Link>
              </li>
              <li>
                <Link to="/kodel-mes" className="hover:text-blue-400 transition-colors">
                  Kodėl mes
                </Link>
              </li>
              <li>
                <Link to="/kontaktai" className="hover:text-blue-400 transition-colors">
                  Kontaktai
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Teisinė informacija</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privatumo-politika" className="hover:text-blue-400 transition-colors">
                  Privatumo politika
                </Link>
              </li>
              <li>
                <Link to="/slapuku-politika" className="hover:text-blue-400 transition-colors">
                  Slapukų politika
                </Link>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-sm text-gray-400">Darbo laikas:</p>
              <p className="text-sm">I–V 9:00–15:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} MB "WSK Logistikos paslaugos". Visos teisės saugomos.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
